const salepifyRefreshCartDraw = () => {
  const cartDrawerSlide = document.querySelector("cart-drawer");
  fetch('/?section_id=cart-drawer')
    .then(d => d.text())
    .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.querySelector("cart-drawer").innerHTML;
        cartDrawerSlide.innerHTML = cartFormInnerHTML;
        window.tlCartGoalEmbed.renderAllCartGoals();
        window.tlAdvancedFreeGift.updateCartData()
    });
}

const salepifyRefreshCartPage = () => {
  const cartElement = document.querySelector("cart-items");
  fetch('/?section_id=template--23965406921011__cart-items')
    .then(d => d.text())
    .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.querySelector("cart-items").innerHTML;
        cartElement.innerHTML = cartFormInnerHTML;
        window.tlCartGoalEmbed.renderAllCartGoals();
        window.tlAdvancedFreeGift.updateCartData();
    });
}

const salepifyRefreshFnc = window.location.pathname == "/cart" ? salepifyRefreshCartPage : salepifyRefreshCartDraw;

// window.TLCustomEventGiftsAdvanced = 1;
window.TLCustomEventCartGoal = 1

// window.addEventListener('TLCustomEvent:FreeGiftsAdvanced-mergeCartTempToCart', () => {
//     salepifyRefreshFnc()
// })
// window.addEventListener('TLCustomEvent:FreeGiftsAdvanced-handleAddGiftAndReload', () => {
//     salepifyRefreshFnc();
//     window.tlAdvancedFreeGift.handleToggle();
//     window.tlAdvancedFreeGift.removeLoading();
//     window.tlAdvancedFreeGift.reRender();
//     window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
// })
// window.addEventListener('TLCustomEvent:FreeGiftsAdvanced-render-needToReload', () => {
//     salepifyRefreshFnc()
// })
// window.addEventListener('TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift', () => {
//     salepifyRefreshFnc()
// })
// window.addEventListener('TLCustomEvent:FreeGiftsAdvanced-reRender-needToReload', () => {
//     salepifyRefreshFnc()
// })


window.addEventListener('TLCustomEvent:CartGoal-getPassedMilestone', () => {
    salepifyRefreshFnc()
})
window.addEventListener('TLCustomEvent:CartGoal-handleAutoAddGift', () => {
    salepifyRefreshFnc()
})
window.addEventListener('TLCustomEvent:CartGoal-handleAddtoCart', () => {
    salepifyRefreshFnc()
})
window.addEventListener('TLCustomEvent:CartGoal-handleApplyDiscountCode', () => {
    salepifyRefreshFnc()
})
